<script lang="ts">
  import Button from '$lib/components/reusable/Button.svelte';
  import Modal from '$lib/components/reusable/Modal.svelte';
  import { client } from '$lib/api/Client';
  import { toastCustom } from '$utils/toasts';
  import DeleteIcon from '$icons/DeleteIcon.svelte';

  export let isOpen: boolean;
  export let onClose: () => void;

  let isDeleting = false;

  async function handleDeleteProject() {
    isDeleting = true;
    try {
      await client.projects.deleteProject();
      toastCustom({
        position: 'bottom-center',
        positive: true,
        title: 'Project successfully deleted.',
      });
      location.reload();
    } catch (error) {
      console.error('Error deleting project:', error);
      toastCustom({
        position: 'bottom-center',
        negative: true,
        title: 'Failed to delete the project. Please try again.',
      });
    } finally {
      isDeleting = false;
      isOpen = false;
    }
  }
</script>

<Modal bind:modalOpen={isOpen} on:close={onClose} title="Delete Project">
  <div class="flex flex-col gap-4">
    <p class="text-gray-dark-10 text-sm">
      Are you sure you want to delete this project? This action cannot be undone.
    </p>
    <Button class="w-full" secondary danger on:click={handleDeleteProject} disabled={isDeleting}>
      {isDeleting ? 'Deleting...' : 'Delete Project'}
    </Button>
  </div>
</Modal>
